import { WallContainer } from "../../../building/wall/WallContainer";
import { Building } from "../../../building/Building";
import { Config } from "../../../config/Config";
import { Vector2, Object3D, BufferGeometry, MeshStandardMaterial, Texture } from "three";
import { THREEUtils } from "../../../utils/THREEUtils";
import { BuildingGeometry } from "../../../building/BuildingGeometry";
import { WallAddon } from "../../addon/WallAddon";
import { ISceneAddon } from "../../addon/ISceneAddon";
import { WainscotTrim } from "./WainscotTrim";
import {Main} from "Main";

export class Wainscot
{
	public wallContainer:WallContainer;
	public height:number = 0;

	private _building:Building;
	private _config:Config;
	private _scene:Object3D;

	private _material: MeshStandardMaterial;
	private _sideGeometry:BufferGeometry;
	private _endGeometry: BufferGeometry;

	private _trim:WainscotTrim;

	constructor(building: Building)
	{
		this._building = building;
		this._config = building.config;
		this._scene = building.scene3D;

		this._material = new MeshStandardMaterial({
			normalMap: this._building.materials.normalMap,
			//normalScale: new Vector2(-1, -1),
			color: 0xffffff,
			envMap: Main.getInstance().content.scene3D.background as Texture,
			roughness: 1,
			metalness: 0,
		});

		this._config.building.wainscot.signal.add(this.onWainscotChange);
		this._config.building.no_walls.signal.add(this.onWainscotChange);
		this._config.colors.wainscot.signal.add(this.onWainscotColorChange);

		this.createWallContainer();
		this._trim = new WainscotTrim(building);
	}

	// called when building size changes
	public updateSize()
	{
		if (this.height > 0)
		{
			var building = this._building;

			this.wallContainer.update(building.config.metrics, this.height, 0, true);

			THREEUtils.scaleUVs(this._sideGeometry, new Vector2(building.config.metrics.length, this.height));
			THREEUtils.scaleUVs(this._endGeometry, new Vector2(building.config.metrics.width, this.height));

			this._trim.updateSize();
		}
	}

	private onWainscotChange = () =>
	{
		var value = this._config.building.wainscot.value;
		var no_walls = this._config.building.no_walls.value;

		if (no_walls)
		{
			// if no walls -> don't show wainscot
			value = 0;
		}

		this.height = value;

		if (value > 0)
		{
			this.wallContainer.show();

			this._trim.show();
			this._trim.updateSize();

			// update cuts?
		}
		else
		{
			this.wallContainer.hide();
			this._trim.hide();
		}
	};

	private createWallContainer()
	{
		this._sideGeometry = BuildingGeometry.createWallGeometry();
		this._endGeometry = BuildingGeometry.createWallGeometry();

		this.wallContainer = new WallContainer({
			material: this._material,
			sideGeometry: this._sideGeometry,
			endGeometryFront: this._endGeometry,
			endGeometryBack: this._endGeometry
		});

		this.wallContainer.add(this._scene);
		this.wallContainer.hide();
	}

	private onWainscotColorChange = (value:number) =>
	{
		this._material.color.set(value);
	};

	// ============================================================================================
	// Manage cuts

	public addNode(node:WallAddon)
	{
		if (this.height)
		{
			this.wallContainer.addNode(node);
			this._trim.addNode(node);
		}
	}

	public updateCuts(addons:{[wallId:string]:ISceneAddon[]})
	{
		if (this.height)
		{
			this.wallContainer.updateCuts(addons);
			this._trim.updateCuts(addons);
		}
	}
}